module.exports = __webpack_public_path__ + "static/img/三维制作画面2.a7faaeab.png";